function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (caption, classes, continueBtnText, doneText, hasNarration, hasPrompt, i18n, isNumber, longestRow, prompt, rows, style, submitUp, title) {
      pug_html = pug_html + "\u003Cdiv class=\"content-fit content-scroll content-ver text-center block-v-md\"\u003E\u003Cdiv class=\"content-scroll-inner block-v-md\"\u003E\u003Ch1 class=\"text-center fade-in\"\u003E" + (null == (pug_interp = title) ? "" : pug_interp) + "\u003C\u002Fh1\u003E\u003Cdiv class=\"table-container\"\u003E\u003Cdiv class=\"table-wrapper\"\u003E\u003Ctable" + (pug_attr("class", pug_classes(["table","slide-up",classes], [false,false,true]), false, true)) + "\u003E\u003Ctbody\u003E";
// iterate rows
;(function(){
  var $$obj = rows;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var row = $$obj[i];
pug_html = pug_html + "\u003Ctr class=\"table-row\"\u003E";
// iterate longestRow.cells
;(function(){
  var $$obj = longestRow.cells;
  if ('number' == typeof $$obj.length) {
      for (var col = 0, $$l = $$obj.length; col < $$l; col++) {
        var n = $$obj[col];
var el = row.cells[col] || ""
if (style.header && i === 0) {
pug_html = pug_html + "\u003Cth class=\"table-cell\"\u003E" + (null == (pug_interp = el) ? "" : pug_interp) + "\u003C\u002Fth\u003E";
}
else {
pug_html = pug_html + "\u003Ctd" + (" class=\"table-cell\""+pug_attr("align", isNumber(el) && "right", true, true)) + "\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["slide-up",`delay-${i}`], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = el) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var col in $$obj) {
      $$l++;
      var n = $$obj[col];
var el = row.cells[col] || ""
if (style.header && i === 0) {
pug_html = pug_html + "\u003Cth class=\"table-cell\"\u003E" + (null == (pug_interp = el) ? "" : pug_interp) + "\u003C\u002Fth\u003E";
}
else {
pug_html = pug_html + "\u003Ctd" + (" class=\"table-cell\""+pug_attr("align", isNumber(el) && "right", true, true)) + "\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["slide-up",`delay-${i}`], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = el) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var row = $$obj[i];
pug_html = pug_html + "\u003Ctr class=\"table-row\"\u003E";
// iterate longestRow.cells
;(function(){
  var $$obj = longestRow.cells;
  if ('number' == typeof $$obj.length) {
      for (var col = 0, $$l = $$obj.length; col < $$l; col++) {
        var n = $$obj[col];
var el = row.cells[col] || ""
if (style.header && i === 0) {
pug_html = pug_html + "\u003Cth class=\"table-cell\"\u003E" + (null == (pug_interp = el) ? "" : pug_interp) + "\u003C\u002Fth\u003E";
}
else {
pug_html = pug_html + "\u003Ctd" + (" class=\"table-cell\""+pug_attr("align", isNumber(el) && "right", true, true)) + "\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["slide-up",`delay-${i}`], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = el) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var col in $$obj) {
      $$l++;
      var n = $$obj[col];
var el = row.cells[col] || ""
if (style.header && i === 0) {
pug_html = pug_html + "\u003Cth class=\"table-cell\"\u003E" + (null == (pug_interp = el) ? "" : pug_interp) + "\u003C\u002Fth\u003E";
}
else {
pug_html = pug_html + "\u003Ctd" + (" class=\"table-cell\""+pug_attr("align", isNumber(el) && "right", true, true)) + "\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["slide-up",`delay-${i}`], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = el) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

if (caption) {
pug_html = pug_html + "\u003Ctr class=\"table-row\"\u003E\u003Ctd" + (" class=\"table-cell\""+pug_attr("colspan", longestRow.cells.length, true, true)+" align=\"center\"") + "\u003E\u003Csmall\u003E" + (null == (pug_interp = caption) ? "" : pug_interp) + "\u003C\u002Fsmall\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
pug_html = pug_html + "\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["slide-footer","block-v-lg",submitUp ? "slide-footer--up slide-down" : "slide-up"], [false,false,true]), false, true)) + "\u003E";
if (hasPrompt) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-touched\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis\" id=\"done-btn\"\u003E" + (null == (pug_interp = doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
if (typeof prompt === "string") {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt text-uppercase text-bold\"\u003E\u003Cdiv class=\"slide-footer-prompt-content content-ver\" id=\"prompt\"\u003E" + (null == (pug_interp = prompt) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis content-ver\" id=\"prompt-btn\"\u003E" + (null == (pug_interp = continueBtnText || doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
if (hasNarration) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-narration\"\u003E\u003Cdiv class=\"narration-progress btn btn-muted\"\u003E\u003Cdiv class=\"narration-progress-bar\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"wave-ellipse\"\u003E\u003Cspan class=\"bullet delay-1 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-2 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-3 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "caption" in locals_for_with ?
        locals_for_with.caption :
        typeof caption !== 'undefined' ? caption : undefined, "classes" in locals_for_with ?
        locals_for_with.classes :
        typeof classes !== 'undefined' ? classes : undefined, "continueBtnText" in locals_for_with ?
        locals_for_with.continueBtnText :
        typeof continueBtnText !== 'undefined' ? continueBtnText : undefined, "doneText" in locals_for_with ?
        locals_for_with.doneText :
        typeof doneText !== 'undefined' ? doneText : undefined, "hasNarration" in locals_for_with ?
        locals_for_with.hasNarration :
        typeof hasNarration !== 'undefined' ? hasNarration : undefined, "hasPrompt" in locals_for_with ?
        locals_for_with.hasPrompt :
        typeof hasPrompt !== 'undefined' ? hasPrompt : undefined, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "isNumber" in locals_for_with ?
        locals_for_with.isNumber :
        typeof isNumber !== 'undefined' ? isNumber : undefined, "longestRow" in locals_for_with ?
        locals_for_with.longestRow :
        typeof longestRow !== 'undefined' ? longestRow : undefined, "prompt" in locals_for_with ?
        locals_for_with.prompt :
        typeof prompt !== 'undefined' ? prompt : undefined, "rows" in locals_for_with ?
        locals_for_with.rows :
        typeof rows !== 'undefined' ? rows : undefined, "style" in locals_for_with ?
        locals_for_with.style :
        typeof style !== 'undefined' ? style : undefined, "submitUp" in locals_for_with ?
        locals_for_with.submitUp :
        typeof submitUp !== 'undefined' ? submitUp : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined));
    ;;return pug_html;};module.exports=template;